import React, { FC } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Box, Text, ButtonAppearance } from '@bechtel/gds';
import { DrawerFooterButtonStyled } from '@bechtel/client-common';
import { t, Trans } from '@lingui/macro';
import { DeleteCaddyProps } from './types';

export const DeleteCaddy: FC<DeleteCaddyProps> = ({ caddyNumber, onCancel, onDelete }) => {
  return (
    <Modal visible={true} style={{ width: '552px', height: '430px' }}>
      <ModalHeader title={t`Delete Caddy`}></ModalHeader>
      <ModalBody>
        <Box
          px={{ sm: '500' }}
          py={{ sm: '600' }}
          justifyContent={{ sm: 'center' }}
          alignItems={{ sm: 'center' }}
          flexGrow={{ sm: '1' }}
        >
          <Text size="500" family="graphik" color="grey.1000" weight="600">
            {t`Are you sure you want to delete the caddy (${caddyNumber})?`}
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
              <Box px={{ sm: '500' }}>
                <Trans>Cancel</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
          <Box>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onDelete}>
              <Box px={{ sm: '500' }}>
                <Trans>Delete</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
